import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, toHandlers as _toHandlers, mergeProps as _mergeProps, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-test-id": "nave-select__header"
}
const _hoisted_2 = {
  key: 1,
  class: "nave-select__search-area mb-2"
}
const _hoisted_3 = { class: "p-input-icon-left" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputIcon = _resolveComponent("InputIcon")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_IconField = _resolveComponent("IconField")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["nave-select", { bordered: _ctx.borderStyle }])
  }, [
    _createElementVNode("div", _mergeProps({
      class: ["nave-select__label", { bordered: _ctx.borderStyle }]
    }, _toHandlers(_ctx.eventList, true), { "data-test-id": "nave-select__button" }), [
      _createElementVNode("span", null, _toDisplayString(_ctx.label ? _ctx.label : _ctx.placeholder), 1),
      _cache[3] || (_cache[3] = _createElementVNode("i", { class: "icon-nav-bullet_down" }, null, -1))
    ], 16),
    (_ctx.showSelectOptions)
      ? (_openBlock(), _createElementBlock("ul", {
          key: 0,
          ref: "listOptions",
          class: "nave-select__list",
          "data-test-id": "nave-select__list",
          onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseLeaveSelectOptions && _ctx.mouseLeaveSelectOptions(...args))),
          onMouseenter: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mouseEnterSelectOptions && _ctx.mouseEnterSelectOptions(...args)))
        }, [
          (_ctx.options.header)
            ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
                _createTextVNode(_toDisplayString(_ctx.options.header) + " ", 1),
                _cache[4] || (_cache[4] = _createElementVNode("i", { class: "icon-nav-bullet_up" }, null, -1))
              ]))
            : _createCommentVNode("", true),
          (_ctx.showSearchInput)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, [
                  _createVNode(_component_IconField, {
                    iconPosition: "left",
                    class: "xp-input-icon"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_InputIcon, null, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createElementVNode("i", { class: "icon-nav-search" }, null, -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_InputText, {
                        type: "text",
                        modelValue: _ctx.searchOption,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchOption) = $event)),
                        placeholder: "Buscar loja",
                        "data-test-id": "nave-select__input"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.getType(_ctx.options.options) === 'object')
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.filteredOptions, (option, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: ($event: any) => (_ctx.optionSelected(index, option))
                }, _toDisplayString(option), 9, _hoisted_4))
              }), 128))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(_ctx.filteredOptions, (option, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  onClick: ($event: any) => (_ctx.optionSelected(option.value, option.text)),
                  class: "d-flex align-items-center",
                  "data-test-id": "nave-select__option"
                }, [
                  (option.icon)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: _normalizeClass([option.icon])
                      }, null, 2))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", null, _toDisplayString(option.text), 1)
                ], 8, _hoisted_5))
              }), 128))
        ], 544))
      : _createCommentVNode("", true)
  ], 2))
}